module.exports = __webpack_public_path__ + "img/app_coaches_top@2x.6830acc1.jpg";